import React from 'react'
import ErrorMessage from '../../UI/messages/ErrorMessage'
import SuccessMessage from '../../../helpers/message/SuccessMessage'
import ScannerWrap from '../../scanner/ScannerWrap'
import { useState } from 'react'
import { useEffect } from 'react'
import { responseError } from '../../../helpers/response/ResponseHelper'
import MyButton from '../../UI/form/MyButton'
import { checkChangeWorkLinePlaceAPI } from '../../../api/workLinePlace/workLinePlaceAPI'
import WorkLinePlaceResult from './result/WorkLinePlaceResult'

const WorkLinePlaceForm = () => {

    const [scanResultTemp, setScanResultTemp] = useState('')
    const [data, setData] = useState(null)
    const [loading, setLoading] = useState(false)
    const [success, setSuccess] = useState('')
    const [error, setError] = useState('')

    useEffect(() => {
        if (scanResultTemp) {
            changeWorkLinePlace()
        }
    }, [scanResultTemp])

    const changeWorkLinePlace = () => {
        setError('')
        setLoading(true)
        setData(null)
        checkChangeWorkLinePlaceAPI({ 
            scaned: scanResultTemp 
        }).then(data => {
            setData(data)
            setLoading(false)
        }).catch(e => {
            setError(responseError(e))
            // setErrorMain(responseError(e))
            setLoading(false)
        })
    }

  return (
    <div>
        <p>
            Відскануйте QR-код за допомогою сканера нижче
        </p>

        <ErrorMessage
            error={error}
        />
        <SuccessMessage 
            success={success}
        />

        {
            process.env.REACT_APP_DEV_TYPE === 'DEV' ?
                <>
                    <MyButton
                        onClick={e => setScanResultTemp('line-place.c464eb56-f0aa-45dd-befb-3630a4adccc9')} // Пакування
                        // onClick={e => setScanResultTemp('line-place.12402370-83f1-4df5-9d95-dea49c9cf13f')} // Намотка
                    >
                        Без камери - умовний сканер - ТИМЧАСОВО (Склад)
                    </MyButton>

                    <MyButton
                        // onClick={e => setScanResultTemp('line-place.c464eb56-f0aa-45dd-befb-3630a4adccc9')} // Пакування
                        onClick={e => setScanResultTemp('line-place.12402370-83f1-4df5-9d95-dea49c9cf13f')} // Намотка
                    >
                        Без камери - умовний сканер - ТИМЧАСОВО (Цех)
                    </MyButton>
                </>
            : ''
        }

        <ScannerWrap
            setResultText={setScanResultTemp}
            isCameraOnly={true}
            // reset={reset}
            // setReset={setReset}
        />

        {
            data ?
                <WorkLinePlaceResult
                    result={data}
                />
            : ''
        }
    </div>
  )
}

export default WorkLinePlaceForm